//@flow
import React from 'react';
import { Card, Modal } from '@material-ui/core';
import useExistingUserTermsOfUse from './hooks/useExistingUserTermsOfUse';
import ExistingUserPage1 from './ExistingUserPage1';
import ExistingUserPage2 from './ExistingUserPage2';
import ExistingUserPage3 from './ExistingUserPage3';

export default function TermsOfUsePrompt() {
    const {
        promptIsShowing,
        pageIndex,
        isOver16,
        selectUserOver16,
        selectUserUnder16,
        hasCheckboxError,
        isChecked,
        toggleIsChecked,
        hasAgeConfirmationError,
        onSubmit,
        isSubmitting,
        isNewUser,
        dateOfBirth,
        setDateOfBirth,
        dateOfBirthErrorMessage,
        dateOfBirthValidated,
        hasDateOfBirthError,
        parentEmail,
        setParentEmail,
        parentEmailErrorMessage,
        hasParentEmailError,
        parentEmailHelperText,
        onSubmitConsentRequest,
        handleGoBack,
        onClose
    } = useExistingUserTermsOfUse();

    return (
        <Modal
            open={promptIsShowing}
            className="modal"
            data-testid="terms-of-use-modal"
        >
            <Card className="terms-of-use-prompt">
                <div className={`page ${pageIndex === 0 ? 'active' : ''}`}>
                    <ExistingUserPage1
                        isOver16={isOver16}
                        selectUserOver16={selectUserOver16}
                        selectUserUnder16={selectUserUnder16}
                        hasAgeConfirmationError={hasAgeConfirmationError}
                        isChecked={isChecked}
                        toggleIsChecked={toggleIsChecked}
                        hasCheckboxError={hasCheckboxError}
                        onSubmit={onSubmit}
                        isSubmitting={isSubmitting}
                    />
                </div>
                <div className={`page ${pageIndex === 1 ? 'active' : ''}`}>
                    <ExistingUserPage2
                        dateOfBirth={dateOfBirth}
                        setDateOfBirth={setDateOfBirth}
                        dateOfBirthErrorMessage={dateOfBirthErrorMessage}
                        dateOfBirthValidated={dateOfBirthValidated}
                        hasDateOfBirthError={hasDateOfBirthError}
                        parentEmail={parentEmail}
                        setParentEmail={setParentEmail}
                        parentEmailErrorMessage={parentEmailErrorMessage}
                        hasParentEmailError={hasParentEmailError}
                        parentEmailHelperText={parentEmailHelperText}
                        onSubmit={onSubmitConsentRequest}
                        onGoBack={handleGoBack}
                        isSubmitting={isSubmitting}
                    />
                </div>
                <div className={`page ${pageIndex === 2 ? 'active' : ''}`}>
                    <ExistingUserPage3
                        parentEmail={parentEmail}
                        onSubmit={onClose}
                        isNewUser={isNewUser}
                    />
                </div>
            </Card>
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./src/v5/termsOfUse/components/TermsOfUsePrompt.jsx